import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://apex-med-tech-backend.vercel.app/api';
const StockContext = createContext();

export function StockProvider({ children }) {
  const [products,  setProducts]  = useState([]);
  const [movements, setMovements] = useState([]);
  const [alerts,    setAlerts]    = useState([]);
  const [stats,     setStats]     = useState(null);
  const [loading,   setLoading]   = useState(false);

  const getH = () => { const t = localStorage.getItem('stockToken'); return t ? { Authorization:`Bearer ${t}` } : {}; };
  const hasToken = () => !!localStorage.getItem('stockToken');

  const fetchAll = useCallback(async () => {
    if (!hasToken()) return;
    setLoading(true);
    try {
      const h = getH();
      const [p,m,a,s] = await Promise.all([
        axios.get(`${API}/stock/products`,  {headers:h}),
        axios.get(`${API}/stock/movements`, {headers:h}),
        axios.get(`${API}/stock/alerts`,    {headers:h}),
        axios.get(`${API}/stock/dashboard`, {headers:h}),
      ]);
      setProducts(p.data.data||[]); setMovements(m.data.data||[]);
      setAlerts(a.data.data||[]);   setStats(s.data.data||null);
    } catch(err) { console.error('Stock fetch:', err.response?.data?.message||err.message); }
    finally { setLoading(false); }
  }, []);

  const addProduct    = async (d)    => { const r = await axios.post(`${API}/stock/products`, d, {headers:getH()}); if(r.data.success) setProducts(p=>[r.data.data,...p]); return r.data; };
  const updateProduct = async (id,d) => { const r = await axios.put(`${API}/stock/products/${id}`, d, {headers:getH()}); setProducts(p=>p.map(x=>x._id===id?r.data.data:x)); return r.data; };
  const deleteProduct = async (id)   => { await axios.delete(`${API}/stock/products/${id}`, {headers:getH()}); setProducts(p=>p.filter(x=>x._id!==id)); };
  const addMovement   = async (d)    => { const r = await axios.post(`${API}/stock/movements`, d, {headers:getH()}); setProducts(p=>p.map(x=>x._id===d.productId?{...x,quantity:r.data.productQuantity}:x)); await fetchAll(); return r.data; };
  const markAlertsRead= async (id='all') => { await axios.put(`${API}/stock/alerts/${id}/read`,{},{headers:getH()}); setAlerts(a=>a.map(x=>(id==='all'||x._id===id)?{...x,isRead:true}:x)); };
  const upgradePlan   = async ()     => { const r = await axios.post(`${API}/stock/upgrade`,{},{headers:getH()}); return r.data; };

  return (
    <StockContext.Provider value={{ products, movements, alerts, stats, loading, unreadAlerts:alerts.filter(a=>!a.isRead).length, fetchAll, addProduct, updateProduct, deleteProduct, addMovement, markAlertsRead, upgradePlan }}>
      {children}
    </StockContext.Provider>
  );
}
export const useStock = () => useContext(StockContext);

